import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	navigationBlockModalTitle: {
		defaultMessage: 'Generated Issues will be lost',
		description:
			'Title of modal shown when user is about to navigate away from the AI issue breakdown',
		id: 'issue-view-common-views.child-issues-panel.ai-issue-breakdown.issue-breakdown-draft-list.navigation-block-modal-title',
	},
	navigationBlockModalBody: {
		defaultMessage:
			'Any changes made to this form will be lost if you leave this page without saving.',
		description:
			'Body of modal shown when user is about to navigate away from the AI issue breakdown',
		id: 'issue-view-common-views.child-issues-panel.ai-issue-breakdown.issue-breakdown-draft-list.navigation-block-modal-body',
	},
	navigationBlockGoBackButton: {
		defaultMessage: 'Cancel',
		description:
			'Text in button that will cancel the attempt at navigating away from the AI issue breakdown',
		id: 'issue-view-common-views.child-issues-panel.ai-issue-breakdown.issue-breakdown-draft-list.navigation-block-go-back-button',
	},
	navigationBlockContinueButton: {
		defaultMessage: 'Continue',
		description:
			'Text in button that will discard the unsaved changes and continue navigating away from the form builder',
		id: 'issue-view-common-views.child-issues-panel.ai-issue-breakdown.issue-breakdown-draft-list.navigation-block-continue-button',
	},
});
